var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { V as VisibleConditionOperatorEnum, e as VisibleConditionEnum, f as VisibleConditionTypeEnum } from "./enums-86f58524.js";
import { type, defaultValue, Component, Schema } from "./decorators/type.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
class VisibleConditionSchema extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "condition");
    __publicField(this, "component");
    __publicField(this, "key");
    __publicField(this, "stringValue");
    __publicField(this, "booleanValue");
    __publicField(this, "numberValue");
    __publicField(this, "valueType");
    __publicField(this, "operator");
  }
}
__decorateClass([
  type(VisibleConditionEnum)
], VisibleConditionSchema.prototype, "condition", 2);
__decorateClass([
  type("string")
], VisibleConditionSchema.prototype, "component", 2);
__decorateClass([
  type("string")
], VisibleConditionSchema.prototype, "key", 2);
__decorateClass([
  type("string")
], VisibleConditionSchema.prototype, "stringValue", 2);
__decorateClass([
  type("boolean")
], VisibleConditionSchema.prototype, "booleanValue", 2);
__decorateClass([
  type("number")
], VisibleConditionSchema.prototype, "numberValue", 2);
__decorateClass([
  type(VisibleConditionTypeEnum)
], VisibleConditionSchema.prototype, "valueType", 2);
__decorateClass([
  type(VisibleConditionOperatorEnum),
  defaultValue(VisibleConditionOperatorEnum.EQUAL)
], VisibleConditionSchema.prototype, "operator", 2);
let VisibleConditionalSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "conditions");
  }
};
__decorateClass([
  type([VisibleConditionSchema]),
  defaultValue([])
], VisibleConditionalSchema.prototype, "conditions", 2);
VisibleConditionalSchema = __decorateClass([
  Component("VisibleConditional")
], VisibleConditionalSchema);
const __vite_glob_0_31 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get VisibleConditionalSchema() {
    return VisibleConditionalSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  VisibleConditionalSchema as V,
  __vite_glob_0_31 as _
};
//# sourceMappingURL=VisibleConditional-7a953c26.js.map
